export function getParsedJwt<T extends object = Record<string, string | number>>(token: string | null): T | undefined {
    if (token === null) {
        return undefined;
    }
    try {
        return JSON.parse(atob(token.split('.')[1]));
    } catch {
        return undefined;
    }
}
